var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16,0.6l-10.9,0c-1.1,0-2.1,0-3.2,0C0.9,0.6,0,1.4,0,2.5c0,2.7,0,5.4,0,8.2L0,12c0,0.3,0.1,0.6,0.3,0.9 c0.4,0.6,0.9,0.9,1.6,1c0.4,0,0.8,0,1.2,0l0.4,0v2.8c0,0.3,0.1,0.5,0.4,0.7c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.3-0.1,0.5-0.2 c0,0,0.1-0.1,0.1-0.1l0.9-0.7c1-0.8,2.1-1.7,3.1-2.5c0.1,0,0.2-0.1,0.2-0.1c2.3,0,4.6,0,6.9,0c0.2,0,0.4,0,0.6-0.1 c0.9-0.2,1.4-1,1.4-1.9c0-3.1,0-6.2,0-9.3C18,1.4,17.2,0.6,16,0.6z M5,13.2c0-0.5-0.3-0.8-0.8-0.8c-0.3,0-0.5,0-0.8,0 c-0.2,0-0.3,0-0.5,0H2c-0.4,0-0.5-0.2-0.5-0.5V2.6c0-0.4,0.2-0.5,0.5-0.5c4.7,0,9.3,0,14,0c0.4,0,0.5,0.2,0.5,0.5 c0,3.1,0,6.2,0,9.3c0,0.3-0.2,0.5-0.5,0.5h-0.8c-2.1,0-4.2,0-6.3,0c0,0,0,0,0,0c-0.3,0-0.5,0.1-0.8,0.3c-0.9,0.7-1.7,1.4-2.6,2.1 L5,15.2l0-0.5C5,14.2,5,13.7,5,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.1,6.8c0.1,0,0.2,0,0.3,0h9.2l0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.3,0,0.5-0.2,0.6-0.5 c0.1-0.2,0.1-0.5-0.1-0.7c-0.1-0.2-0.4-0.3-0.7-0.3l-7.8,0c-0.5,0-1.1,0-1.6,0C3.9,5.3,3.6,5.6,3.5,6C3.5,6.3,3.7,6.7,4.1,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.9,9.1c0.5,0,0.8-0.3,0.8-0.7c0-0.2-0.1-0.4-0.2-0.5C9.4,7.8,9.2,7.7,8.9,7.7c-1.5,0-3.1,0-4.6,0 c-0.2,0-0.5,0.1-0.6,0.2C3.6,8,3.5,8.2,3.5,8.4c0,0.4,0.3,0.7,0.8,0.7l2.3,0L8.9,9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0ac9c15aed7964abc365565ad6191472.svg";
export { ForwardRef as ReactComponent };